import React from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import HeroSection from "../../components/HeroSection/HeroSection";
import HeroCaption from "../../components/HeroCaption/HeroCaption";
import ProgramDescriptionResponsive from "../../components/ProgramDescriptionResponsive/ProgramDescriptionResponsive";
import ResourcesResponsive from "../../components/ResourcesResponsive/ResourcesResponsive";
import MBAChoiceOfElectivesResponsive from "../../components/MBAChoiceOfElectivesResponsive/MBAChoiceOfElectivesResponsive";

const BTechCivilProgramPage = () => {
	return (
		<PageWrapper className="mt-n6">
			<HeroSection className="bg-page-background-7">
				<HeroCaption
					title="Academics"
					position="bottom-left"
					breadcrumb={true}
					breadcrumbPrefix="Home"
				/>
			</HeroSection>
			<ProgramDescriptionResponsive
				title="B.Tech in Civil Engineering"
				desc="Our B.Tech in Civil Engineering program is designed to provide students with a comprehensive understanding of civil engineering principles, including structures, construction, materials, and management. Graduates of this program are well-equipped to pursue careers in construction, infrastructure, or project management.
				"
			/>
			{/* <MBAChoiceOfElectivesResponsive /> */}
			{/* <ResourcesResponsive headerContent={""} /> */}
		</PageWrapper>
	);
};

export default BTechCivilProgramPage;
